/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function TitleBar(props) {
  return (
    <div
      css={css`
        display: table;
        padding: 10px;
        box-shadow: ${globals.cardShadow};
        background-color: #ffffff;
        text-align: center;
      `}
    >
      <div
        css={css`
          display: table-cell;
          vertical-align: middle;
        `}
      >
        <a href="https://dailybruin.com">
          <img
            css={css`
              max-width: 84px;
              margin: 8px;

              ${globals.phone} {
                max-width: 54px;
              }
            `}
            src="https://dailybruin.com/images/2017/03/db-logo.png"
          />
        </a>
      </div>
      <div
        css={css`
          display: table-cell;
          vertical-align: middle;
        `}
      >
        <h1
          css={css`
            font-size: 36px;
            font-weight: bold;
            margin: 0;
            ${globals.tablet} {
              font-size: 24px;
            }
            ${globals.phone} {
              font-size: 18px;
            }
          `}
        >
          {props.title}
        </h1>
        <hr
          css={css`
            width: 90%;
            border: 1px solid black;
          `}
        ></hr>
        <h3
          css={css`
            font-size: 14px;
            font-weight: normal;
            margin: 0;
            ${globals.phone} {
              font-size: 12px;
            }
          `}
        >
          {props.explainer}
        </h3>
      </div>
    </div>
  );
}
